// Centralized user role mapping for display
export const USER_ROLE_LABELS: Record<string, string> = {
  USER: 'Individual User',
  INVESTIGATOR: 'Investigator (Human)',
  MEDIATOR: 'Mediator',
  EVIDENCE_SCOUT: 'Evidence Scout (Human)',
  AI_AGENT_EVIDENCE_SCOUT: 'AI Agent Evidence Scout',
  AI_AGENT_INVESTIGATOR: 'AI Agent Investigator',
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super Admin',
  SuperAdmin: 'Super Admin',
  CAREGIVER: 'Family Caregiver',
  Caregiver: 'Family Caregiver',
  CERTIFICATION_AUTHORITY: 'Certification Authority',
  SALES_AGENT: 'Sales Agent',
  BUSINESS_CONTENT_CREATOR: 'Business Content Creator',
  BusinessContentCreator: 'Business Content Creator',
};

export const USER_ROLE_DESCRIPTIONS: Record<string, string> = {
  USER: 'Standard user account for reporting fraud, viewing trust scores, and using platform features.',
  INVESTIGATOR: 'Human investigator to review fraud reports, conduct investigations, and resolve cases.',
  MEDIATOR: 'Mediate disputes between users, help resolve conflicts, and facilitate fair outcomes.',
  EVIDENCE_SCOUT: 'Human evidence scout to source and verify fraud-related data from public records.',
  AI_AGENT_EVIDENCE_SCOUT: 'Autonomous AI agent designed to perform evidence collection tasks with machine precision and real-time processing capabilities.',
  AI_AGENT_INVESTIGATOR: 'Advanced AI investigator agent capable of automated fraud analysis, pattern recognition, and case resolution at scale.',
  ADMIN: 'Platform administrator with full access.',
  SUPER_ADMIN: 'System owner with full Family Care configuration, audit, and override access.',
  SuperAdmin: 'System owner with full Family Care configuration, audit, and override access.',
  CAREGIVER: 'Guardian AI employee assigned to Family Care visits.',
  Caregiver: 'Guardian AI employee assigned to Family Care visits.',
  CERTIFICATION_AUTHORITY: 'Government agency or licensed body that issues and manages professional certifications for investigators and evidence scouts.',
  BUSINESS_CONTENT_CREATOR: 'Creator account focused on business social content and caption generation workflows.',
  BusinessContentCreator: 'Creator account focused on business social content and caption generation workflows.',
};
